
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import { CompanyClient, EmployeeClient, ImportDataClient } from '@/services/Services';
import InfoModal from '@/components/modals/infoModal.vue';
import store from '@/store';
import * as OM from '@/Model';
import * as VM from '@/viewModel';
import { readonly } from 'vue';

@Options({})
export default class AddNewPremisesModal extends Vue {

    @Prop({
        default: () => new OM.Premises()
    }) premises: OM.Premises;

    @Prop() callback: any;

    localPremisesType: OM.Premises = new OM.Premises();

    created() {
        this.localPremisesType = {...this.premises};
    }

    get isReadOnly() {
        return store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    savePremises() {
        CompanyClient.addOrEditPremises(this.localPremisesType)
        .then(x => {
            this.callback();
        })
        .catch(y => {
            this.$opModal.show(InfoModal, {
                text:this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: this.$localizationService.getLocalizedValue("Something went wrong. Retry", "Something went wrong. Retry"),
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => {
                    this.callback();
                }
            })
        })
    }
    
}
